<div class="dialog-container">
  <mat-icon class="warning-icon">warning</mat-icon>
  <h2 class="title">{{data.title}}</h2>
  <div class="buttons-container" mat-dialog-actions>
    <button *ngIf="data.showCancel" mat-button class="cancel-button" (click)="cancel()">Cancel</button>
    <button mat-button class="confirm-button" (click)="confirm()">Confirm</button>
  </div>
</div>
